import { render, staticRenderFns } from "./PublicNavbarLeis.vue?vue&type=template&id=527b8d69&scoped=true&"
import script from "./publicNavbarLeis.ts?vue&type=script&lang=ts&"
export * from "./publicNavbarLeis.ts?vue&type=script&lang=ts&"
import style0 from "./PublicNavbarLeis.vue?vue&type=style&index=0&id=527b8d69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b8d69",
  null
  
)

export default component.exports